/** What a variant is a cut of. Mirrors the CHECK on `variant.edition`. */
export const EDITIONS = ['censored', 'uncensored', 'uncensored_leaked', 'other'] as const;

export type Edition = (typeof EDITIONS)[number];

/** The result of the last time an episode was resolved. Mirrors `episode.status`. */
export const EPISODE_STATUSES = ['unchecked', 'ok', 'cdn_unresolvable', 'gone', 'error'] as const;

export type EpisodeStatus = (typeof EPISODE_STATUSES)[number];

/** Mirrors `term.kind`. */
export const TERM_KINDS = ['genre', 'maker', 'series', 'label', 'tag'] as const;

export type TermKind = (typeof TERM_KINDS)[number];

/** Mirrors `asset.kind`; see the table comment for which owner has which. */
export const ASSET_KINDS = ['cover', 'preview_video', 'preview_image', 'preview_sprite', 'preview_vtt', 'photo'] as const;

export type AssetKind = (typeof ASSET_KINDS)[number];

export const ASSET_OWNER_KINDS = ['variant', 'episode', 'person'] as const;

export type AssetOwnerKind = (typeof ASSET_OWNER_KINDS)[number];

export const ASSET_STATUSES = ['pending', 'stored', 'failed', 'gone'] as const;

export type AssetStatus = (typeof ASSET_STATUSES)[number];
